import React,
{
  useEffect,
  useState,
  useCallback
}
from "react";

import axios
from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function OwnerQRCode() {

  const restaurantId =
    localStorage.getItem(
      "restaurantId"
    );

  const [
    qrUrl,
    setQrUrl
  ] = useState("");

  const [
    menuUrl,
    setMenuUrl
  ] = useState("");

  const [
    loading,
    setLoading
  ] = useState(false);

  /*
  FETCH QR DATA
  */

/*
FETCH QR DATA
*/

const fetchQR = useCallback(async () => {

  try {

    setLoading(true);

    const res =
      await axios.get(
        `${BASE_API}/restaurants/${restaurantId}/qr`
      );

    setQrUrl(
      res.data.qrUrl || ""
    );

    setMenuUrl(
      res.data.menuUrl || ""
    );

  }
  catch (error) {

    console.error("QR fetch error");

    alert("Failed to load QR");

  }
  finally {

    setLoading(false);

  }

}, [restaurantId]);

useEffect(() => {

  fetchQR();

}, [fetchQR]);
  /*
  COPY LINK
  */

  const copyLink =
    () => {

    if (!menuUrl) return;

    navigator.clipboard.writeText(
      menuUrl
    );

    alert(
      "Menu link copied"
    );

  };

  /*
  DOWNLOAD QR
  */

  const downloadQR =
    () => {

    if (!qrUrl) return;

    const link =
      document.createElement(
        "a"
      );

    link.href =
      qrUrl;

    link.download =
      "restaurant-qr.png";

    link.click();

  };

  /*
  PRINT QR
  */

  const printQR =
    () => {

    if (!qrUrl) return;

    const printWindow =
      window.open(
        "",
        "_blank"
      );

    printWindow.document.write(
      `
        <html>
          <body style="text-align:center;">
            <h2>Restaurant QR Code</h2>
            <img src="${qrUrl}" style="width:300px;" />
          </body>
        </html>
      `
    );

    printWindow.document.close();

    printWindow.print();

  };

  /*
  SHARE WHATSAPP
  */

  const shareWhatsApp =
    () => {

    if (!menuUrl) return;

    const message =
      `Check out our restaurant menu:\n${menuUrl}`;

    const whatsappUrl =
      `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(
      whatsappUrl,
      "_blank"
    );

  };

  /*
  SHARE INSTAGRAM
  */

  const shareInstagram =
    () => {

    if (!menuUrl) return;

    navigator.clipboard.writeText(
      menuUrl
    );

    alert(
      "Menu link copied!\nPaste it in Instagram bio or story."
    );

  };

  return (

    <div style={styles.container}>

      <h2>
        Restaurant QR Code
      </h2>

      {loading && (
        <p>
          Loading QR...
        </p>
      )}

      {!loading &&
        qrUrl && (

        <div style={styles.card}>

          <img
            src={qrUrl}
            alt="QR Code"
            style={styles.qr}
          />

          <div style={styles.actions}>

            <button
              style={styles.btn}
              onClick={downloadQR}
            >
              Download QR
            </button>

            <button
              style={styles.btn}
              onClick={printQR}
            >
              Print QR
            </button>

            <button
              style={styles.btn}
              onClick={fetchQR}
            >
              Refresh
            </button>

            <button
              style={styles.whatsappBtn}
              onClick={shareWhatsApp}
            >
              Share WhatsApp
            </button>

            <button
              style={styles.instagramBtn}
              onClick={shareInstagram}
            >
              Share Instagram
            </button>

          </div>

        </div>

      )}

      {/* MENU LINK */}

      {menuUrl && (

        <div style={styles.linkBox}>

          <h3>
            Menu URL
          </h3>

          <input
            value={menuUrl}
            readOnly
            style={styles.linkInput}
          />

          <button
            style={styles.copyBtn}
            onClick={copyLink}
          >
            Copy Link
          </button>

        </div>

      )}

    </div>

  );

}
const styles = {

  container: {
    padding: "24px",
    minHeight: "100vh",
    background: "#f5f6fa",
    fontFamily: "Segoe UI, sans-serif",

    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },

  /* CARD */

  card: {
    marginTop: "20px",

    background: "#ffffff",

    padding: "24px",

    borderRadius: "16px",

    boxShadow:
      "0 8px 20px rgba(0,0,0,0.08)",

    textAlign: "center",

    width: "100%",
    maxWidth: "420px"
  },

  /* QR IMAGE */

  qr: {
    width: "250px",
    maxWidth: "100%",
    height: "auto",

    marginBottom: "18px",

    borderRadius: "12px",

    border: "1px solid #eee"
  },

  /* BUTTONS GRID */

  actions: {
    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(140px, 1fr))",

    gap: "12px",

    marginTop: "10px"
  },

  /* PRIMARY BUTTON */

  btn: {
    padding: "12px",

    border: "none",

    borderRadius: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    cursor: "pointer",

    fontWeight: "600",

    fontSize: "14px",

    transition: "0.2s",

    boxShadow:
      "0 4px 12px rgba(255,106,0,0.4)"
  },

  /* WHATSAPP */

  whatsappBtn: {
    padding: "12px",

    border: "none",

    borderRadius: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    cursor: "pointer",

    fontWeight: "600",

    fontSize: "14px"
  },

  /* INSTAGRAM */

  instagramBtn: {
    padding: "12px",

    border: "none",

    borderRadius: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    cursor: "pointer",

    fontWeight: "600",

    fontSize: "14px"
  },

  /* LINK BOX */

  linkBox: {
    marginTop: "28px",

    background: "#ffffff",

    padding: "20px",

    borderRadius: "14px",

    boxShadow:
      "0 6px 14px rgba(0,0,0,0.08)",

    width: "100%",
    maxWidth: "420px"
  },

  /* LINK INPUT */

  linkInput: {
    width: "100%",

    padding: "12px",

    borderRadius: "10px",

    border: "1px solid #ddd",

    marginBottom: "12px",

    fontSize: "14px",

    background: "#fafafa"
  },

  /* COPY BUTTON */

  copyBtn: {
    width: "100%",

    padding: "12px",

    border: "none",

    borderRadius: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    cursor: "pointer",

    fontWeight: "600",

    fontSize: "15px",

    boxShadow:
      "0 4px 12px rgba(255,106,0,0.4)"
  }

};